import Base from "./base";

export default class Vevopay extends Base {
	makeExternalPayment(newStep) {
		const { iban, stake } = this.state;
		this.props.externalFunc.makeDeposit(
			{
				processType: "papara",
				paymentType: "papara",
				iban,
				amount: stake,
			},
			(data) => {
				this.setState({
					externalUrl: data.url,
					currentStep: newStep,
				});
			}
		);
	}

	makeExternalPaymentWithBonus(newStep, bonusId) {
		const { iban, stake } = this.state;
		this.props.externalFunc.makeDeposit(
			{
				processType: "papara",
				paymentType: "papara",
				iban,
				amount: stake,
				claimsBonus: true,
				bonusId: bonusId,
			},
			(data) => {
				this.setState({
					externalUrl: data.url,
					currentStep: newStep,
				});
			}
		);
	}
}
